import {createSelector} from 'reselect';

const getRootSheet = (state: any) => state.SheetReducer;

export const selectrootsheettype = createSelector(
  [getRootSheet],
  SheetReducer => SheetReducer,
);
